export default __webpack_public_path__ + "static/media/balloon.f7e830bf.png";